import Client from './HttpClient';

const fakeLogin = (payload) => {
	return Client.post(
		'/oauth-api/api/v1/login/merchants',
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

const login = (payload) => {
	return Client.post(
		`/oauth-api/login`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

const chooseBranch = (val) => {
	return Client.post(`/oauth-api/api/v1/abn/auth`, val);
};

const confirm = (payload) => {
	return Client.post(
		`/oauth-api/oauth/authorize`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

export default {
	fakeLogin,
	login,
	confirm,
	chooseBranch,
};
